module.exports = __webpack_public_path__ + "img/lock.d5684269.svg";